import { get, put, post, remove } from "./apiClient";
import { uriWithQueryStringParams } from "../utils/urlUtils";

export default {
  async getSlideshowsForFacility(facilityId) {
    return await get(
      uriWithQueryStringParams("reportSlideshow", { facilityId })
    );
  },

  async getSlideshowsForFacilityBySlideId(slideId, facilityId) {
    return await get(
      `slide/${encodeURIComponent(slideId)}/facility/${encodeURIComponent(
        facilityId
      )}`
    );
  },

  async getSlideshow(id) {
    return await get(`reportSlideshow/${encodeURIComponent(id)}`);
  },

  async setSlideshowActiveStatus(id, activeStatus) {
    return await put(
      uriWithQueryStringParams(`reportSlideshow/${encodeURIComponent(id)}`, {
        isActive: activeStatus
      })
    );
  },

  async deleteSlideshow(id) {
    return await remove(`reportSlideshow/${encodeURIComponent(id)}`);
  },

  async deleteSlide(id) {
    return await remove(`slide/${encodeURIComponent(id)}`);
  },

  async getSlide(id) {
    return await get(`slide/${encodeURIComponent(id)}`);
  },

  async saveSlideshow(data) {
    const url = "reportSlideshow/save";

    if (data.id) {
      return await put(url, data);
    } else {
      return await post(url, data);
    }
  }
};
